import React from 'react';
import { LazyMotion, domAnimation } from 'framer-motion';
import { Hero } from './components/sections/Hero';
import { TrustStats } from './components/sections/TrustStats';
import { Transformation } from './components/sections/Transformation';
import { TaglineCta } from './components/sections/TaglineCta';
import { KeyBenefits } from './components/sections/KeyBenefits';
import { Tomos } from './components/sections/Tomos';
import { ExerciseCardDetail } from './components/sections/ExerciseCardDetail';
import { InsideLook } from './components/sections/InsideLook';
import { Testimonials } from './components/sections/Testimonials';
import { SystemSteps } from './components/sections/SystemSteps';
import { Bonuses } from './components/sections/Bonuses';
import { WhatYouReceive } from './components/sections/WhatYouReceive';
import { Pricing } from './components/sections/Pricing';
import { ValueComparison } from './components/sections/ValueComparison';
import { Guarantee } from './components/sections/Guarantee';
import { FAQ } from './components/sections/FAQ';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
import { StickyCTA } from './components/ui/StickyCTA';
export function App() {
  return <LazyMotion features={domAnimation} data-id="element-0" data-mp="5yjetptzbev">
      <div className="w-full min-h-full bg-white font-body text-ink" data-id="element-1" data-mp="4wx1t3d72hu">
        <main data-id="element-2" data-mp="2zld1r8m3ndb0">
          <Hero data-id="element-3" data-mp="2zlv84y2h77wn" />
          <TrustStats data-id="element-4" data-mp="2zmeoiach9o8k" />
          <Transformation data-id="element-5" data-mp="2zmwlj96ys6hj" />
          <TaglineCta data-id="element-6" data-mp="33mowfsjtyoq2" />
          <KeyBenefits data-id="element-7" data-mp="33lwyib2rgewm" />
          <Tomos data-id="element-8" data-mp="33nghwajpr62m" />
          <ExerciseCardDetail data-id="element-9" data-mp="33myix65o2dr0" />
          <InsideLook data-id="element-10" data-mp="38m1fs3bhtdnw" />
          <Testimonials data-id="element-11" data-mp="38li77d7qg1mj" />
          <SystemSteps data-id="element-12" data-mp="38k6uup081ljt" />
          <Bonuses data-id="element-13" data-mp="38num1hi71vvd" />
          <WhatYouReceive data-id="element-14" data-mp="3dkl42adk71jf" />
          <Pricing data-id="element-15" data-mp="3dlw727z6k59h" />
          <ValueComparison data-id="element-16" data-mp="3dmfqxu8e53q5" />
          <Guarantee data-id="element-17" data-mp="3dii4aymltu1i" />
          <FAQ data-id="element-18" data-mp="nvstj3irmlvf" />
          <FinalCTA data-id="element-19" data-mp="nwc0xqashrv7" />
        </main>
        <Footer data-id="element-20" data-mp="nvaq9mxor7e0" />
        <StickyCTA data-id="element-21" data-mp="nxwxflgnzkvp" />
      </div>
    </LazyMotion>;
}